import { decodeHTML } from "entities";

// Some merchant-entered names (menus, categories) arrive from the API with
// HTML entities (e.g. "Caf&eacute;"). React renders text literally, so decode
// them before display. The result is still rendered as text, not HTML.
export const decodeHtmlEntities = (value: string): string =>
  value ? decodeHTML(value) : value;
